const faqs = [
  {
    q: '神马视频是否需要注册或付费？',
    a: '完全不需要！神马视频承诺永久免费观影，无需注册、无需登录、无需付费，打开网页即可畅享西瓜视频免费、菠萝视频、青青草视频等平台的海量影视资源，真正做到零门槛观影。',
  },
  {
    q: '视频播放卡顿怎么办？如何获得最佳观影体验？',
    a: '神马视频采用智能CDN加速和多线路切换技术，默认提供1080P高清画质。如果遇到卡顿，建议切换备用播放线路或稍等片刻让缓冲完成。为保证流畅度，推荐使用Chrome、Edge等现代浏览器，并保持网络稳定。',
  },
  {
    q: '神马视频的片源更新频率如何？',
    a: '我们每日24小时不间断更新片源，热门电影和电视剧通常在官方上线后数小时内即可在神马视频观看。西瓜视频免费专区、菠萝视频热播榜、青青草视频最新剧集等内容均保持与源站同步更新。',
  },
  {
    q: '支持哪些设备观看？手机能看吗？',
    a: '神马视频全面适配PC端、平板电脑和移动手机端，无论您使用Windows、Mac、iOS还是Android设备，都能获得优质的观影体验。移动端页面经过专门优化，流量消耗更低、加载更快。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            关于神马视频，您想了解的都在这儿
          </p>
        </div>
        <div className="max-w-3xl mx-auto space-y-4">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-background-100 rounded-xl p-5 md:p-6">
              <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 mb-2">
                {faq.q}
              </h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {faq.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}